import React from "react";
import { LOGO_URL } from "@/lib/constants";

// A logo é um arquivo QUADRADO com fundo preto próprio.
// Exibimos como um "tile" quadrado com cantos arredondados (squircle) e fundo preto,
// para a logo ficar perfeitamente alinhada, sem o antigo disco redondo que destoava.
export const BrandMark = ({ size = 40, className = "" }) => (
  <span
    className={`inline-flex shrink-0 items-center justify-center overflow-hidden rounded-[24%] bg-black ring-1 ring-black/10 shadow-[0_6px_18px_rgba(20,19,22,0.18)] ${className}`}
    style={{ width: size, height: size }}
  >
    <img
      src={LOGO_URL}
      alt="LC Produção"
      className="h-full w-full object-cover"
    />
  </span>
);

export const BrandWordmark = ({ className = "", subtitle = true }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <BrandMark size={44} />
    <div className="leading-tight">
      <div className="font-serif text-lg font-semibold tracking-wide text-[color:var(--brand-graphite)]">
        LC Produção
      </div>
      {subtitle && (
        <div className="text-[10px] uppercase tracking-[0.22em] text-[color:var(--brand-muted)]">
          Central do seu evento
        </div>
      )}
    </div>
  </div>
);
